const isSidebarExpanded = () => {
  return window.localStorage.getItem('is_sidebar_expanded') || 1
}

const getDefaultState = () => {
  return {
    isCallingApi: {},
    isLoadingFullPage: true,
    loadingFlg: true,
    isDisableSideMenuItem: false,
    error: '',
    toastMessage: '',
    isNegativeToastMessage: false,
    breadcrumb: [],
    isSidebarExpanded: isSidebarExpanded() || 1,
  }
}

const state = getDefaultState()

const mutations = {
  SET_IS_CALLING_API(state, { url, status }) {
    state.isCallingApi[url] = status
    // reactive state
    state.isCallingApi = { ...state.isCallingApi }
  },
  SET_ERROR(state, payload) {
    state.error = payload
  },
  SET_TOAST_MESSAGE(state, payload) {
    state.toastMessage = payload
  },
  SET_IS_NEGATIVE_TOAST_MESSAGE(state, payload) {
    state.isNegativeToastMessage = payload
  },
  RESET_TOAST_MESSAGE(state) {
    state.toastMessage = ''
  },
  RESET_IS_NEGATIVE_TOAST_MESSAGE(state) {
    state.isNegativeToastMessage = false
  },
  SET_BREADCRUMB(state, payload) {
    state.breadcrumb = payload
  },
  SET_LOADING_FLAG(state, payload) {
    state.loadingFlg = payload
  },
  SET_IS_SIDEBAR_EXPANDED(state, payload) {
    state.isSidebarExpanded = payload
    window.localStorage.setItem('is_sidebar_expanded', payload)
  },
  SET_IS_DISABLE_SIDE_MENU_ITEM(state, payload) {
    state.isDisableSideMenuItem = payload
  },
}

const actions = {
  setLoadingFlag({ commit }, payload) {
    commit('SET_LOADING_FLAG', payload)
  },
  setIsSidebarExpanded({ commit }, payload) {
    commit('SET_IS_SIDEBAR_EXPANDED', payload)
  },
  setIsDisableSideMenuItem({ commit }, payload) {
    commit('SET_IS_DISABLE_SIDE_MENU_ITEM', payload)
  },
}

export default {
  state,
  mutations,
  actions,
}
